import React from 'react';

import { Box } from '@mui/material';
import { useTranslation } from 'next-i18next';

import LikeAndShareCourse from '@components/share/custom/likeAndShareCourse';
import PurchaseRemark from '@components/share/custom/purchaseRemark';
import { useBreakpointV2 } from '@helpers/use';
import { CourseEntity } from '@redux/course/type/courseDetailType';

type PurchaseButtonWithRemarkProps = {
  remarkText: string;
  isFooter?: boolean;
  isDisableActionIcon?: boolean;
  courseDetailSeo: CourseEntity;
};

const PurchaseButtonWithRemark = ({
  remarkText,
  isFooter = false,
  isDisableActionIcon = false,
  courseDetailSeo,
}: PurchaseButtonWithRemarkProps) => {
  const { isMobile } = useBreakpointV2();
  const { t } = useTranslation('store_course');

  return (
    <Box
      display="flex"
      justifyContent={isFooter ? 'flex-end' : 'flex-start'}
      alignItems="center"
      width="100%"
      height={isFooter ? '100%' : '60px'}
      sx={{
        mt: {
          lg: isFooter ? '16px' : '0px',
        },
      }}
    >
      <PurchaseRemark
        title={t(remarkText)}
        icon="fa-light fa-times-circle"
        isFooter={isFooter}
        style={{ width: isFooter && isMobile ? '200px' : '100%' }}
      />
      {!isDisableActionIcon && <LikeAndShareCourse courseDetailSeo={courseDetailSeo} />}
    </Box>
  );
};

export default PurchaseButtonWithRemark;
